import { yup } from '@framework/validation/initYup.ts';
import { ExpressionType } from '../../IExpression.ts';
import { createExpressionType } from '../../IExpressionType.ts';
import { ReferencePlainValueSchema } from '../../validation/ReferencePlainValueSchema.ts';
import { type IValueExpression } from './IValueExpression.ts';

export const ValueExpressionType = createExpressionType<IValueExpression>({
  type: ExpressionType.Value,
  schema: yup
    .object({
      type: yup
        .string()
        .exact(ExpressionType.Value)
        .required()
        .default(ExpressionType.Value),
      value: ReferencePlainValueSchema.label('Valore')
        .default(null)
        .defined()
        .nullable(),
    })
    .noUnknown(),
  evaluate(expression, scope) {
    return expression.value;
  },
  getReferences(expression: IValueExpression) {
    return [];
  },
  toString(expression) {
    return expression.value?.toString() ?? 'null';
  },
});
